<template>
  <div class="article-frame sup-page-frame">
    <div class="article-box sup-page-box">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_kyc_banner.jpg')" alt="KYC認証（本人確認）方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="sup-page-title">
          KYC認証（本人確認）方法
        </h1>

        <p class="sup-page-lead">
          初回の出金にはKYC認証（本人確認）の完了が必要です。以下の手順で基本設定を完了してください。
        </p>
        <div class="sup-steps-box">
          <!-- ステップ1タイトル -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 1
            </p>
            <p class="sup-step-num sup-step-num--sub">
              個人情報の入力と携帯番号の認証
            </p>
          </div>

          <p class="sup-step-desc">
            KYC認証を行う前に、<br>個人情報の入力と携帯番号の認証を完了する必要があります。
          </p>

          <p class="sup-content-list-item">
            ➊ ホーム画面の「詳細」＞「アカウント認証」をタップ
          </p>

          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_kyc_1.jpg')" alt="アカウント認証 画面1">
          </div>
          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_kyc_2.jpg')" alt="アカウント認証 画面2">
          </div>

          <div class="sup-content-list">
            <p class="sup-content-list-item">
              ➋ 個人情報の入力を完了させる
            </p>
            <p class="sup-content-list-item">
              ➌ 携帯番号を入力し、「認証」をタップして携帯番号認証を完了させる
            </p>
            <p class="sup-content-list-item">
              ➍ 出金パスワード（4桁の数字）を設定
            </p>
            <p class="sup-content-list-item">
              ➎「次へ」をタップすると個人情報の設定完了
            </p>
          </div>

          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_kyc_3.jpg')" alt="個人情報入力 画面">
          </div>
          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_kyc_4.jpg')" alt="携帯番号認証 画面">
          </div>

          <hr class="sup-step-divider">

          <!-- ※携帯番号認証方法※ -->
          <p class="sup-steps-box-title">
            ※携帯番号認証方法※
          </p>
          <p class="sup-step-desc">
            携帯番号を入力し、右側の「認証」ボタンを押すと、認証コードがSMSで送信されます。<br>届いた6桁の認証コードを入力し、「認証」ボタンを押すと携帯番号の認証が完了します。
          </p>
          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_kyc_5.jpg')" alt="携帯番号認証方法">
          </div>
        </div>
        <div class="sup-steps-box sup-steps-box--mt">
          <!-- ステップ2タイトル -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 2
            </p>
            <p class="sup-step-num sup-step-num--sub">
              KYC書類（本人確認書類）を用意
            </p>
          </div>

          <p class="sup-step-desc">
            KYC認証には、「身分証明書」と「住所確認用書類」の2点が必要です。片方のみの提出ではKYC認証は完了することはできません。それぞれ下記の説明に沿ってご用意ください。
          </p>

          <hr class="sup-step-divider">

          <!-- 1. 身分証明書 -->
          <div class="sup-doc-section">
            <p class="sup-doc-title">
              1. 身分証明書
            </p>
            <p class="sup-step-desc">
              身分証明書として認められるもの（いずれか1点）：
            </p>
            <div class="sup-content-list">
              <p class="sup-content-list-item">
                ・運転免許証（表面・裏面）
              </p>
              <p class="sup-content-list-item">
                ・パスポート（顔写真ページ）
              </p>
              <p class="sup-content-list-item">
                ・マイナンバーカード（表面のみ）
              </p>
              <p class="sup-content-list-item">
                ・住民基本台帳カード（表面・裏面）
              </p>
              <p class="sup-content-list-item">
                ・在留カード（表面・裏面）
              </p>
              <p class="sup-content-list-item">
                ・特別永住者証明書（表面・裏面）
              </p>
            </div>
            <p class="sup-step-desc">
              上記いずれかの書類と、「勝WIN認証用」および「提出日の日付」を記載した紙を一緒に持ち、<br>書類と顔全体がはっきり写るセルフィー（自撮り写真）を撮影してください。<br>必要に応じて、書類の両面もそれぞれ撮影してください。
            </p>
            <!-- 横幅フル画像 -->
            <div class="sup-step-img-wrap sup-step-img-wrap--full">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_kyc_6.jpg')" alt="身分証明書 サンプル">
            </div>
            <!-- 注意事項ボックス -->
            <div class="sup-caution-box">
              <p class="sup-caution-title">
                ※注意事項※
              </p>
              <div class="sup-caution-list">
                <p>➊ 文書全体が写っていない画像は受け付けできません。必ず書類の四隅が写るようにご撮影ください。</p>
                <p>➋ 書類に記載された内容（氏名、住所など）がはっきり確認できる鮮明な写真をご提出ください。</p>
                <p>➌  画像は編集ソフトやアプリ等で加工せず、そのまま送付してください。加工された画像は無効となり、受け付けできません。</p>
                <p>➍ 有効期限内の書類をご提出ください。 </p>
              </div>
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- 2. 住所確認用書類 -->
          <div class="sup-doc-section">
            <p class="sup-doc-title">
              2. 住所確認用書類
            </p>
            <p class="sup-step-desc">
              住所確認用書類として認められるもの（いずれか1点）：
            </p>
            <div class="sup-content-list">
              <p class="sup-content-list-item">
                ・住民票
              </p>
              <p class="sup-content-list-item">
                ・公共料金または携帯電話の請求書
              </p>
              <p class="sup-content-list-item">
                ・クレジットカードの請求書
              </p>
            </div>
            <p class="sup-step-desc">
              上記いずれかの書類と、「勝WIN認証用」および「提出日の日付」を記載した紙を一緒に、<br>正面から全体がはっきり写るように撮影してください。<span class="sup-text-red">※セルフィー（自撮り）は不要です。</span>
            </p>
            <!-- 横幅フル画像 -->
            <div class="sup-step-img-wrap sup-step-img-wrap--full">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_kyc_7.jpg')" alt="住所確認書類 サンプル">
            </div>
            <!-- 注意事項ボックス -->
            <div class="sup-caution-box">
              <p class="sup-caution-title">
                ※注意事項※
              </p>
              <div class="sup-caution-list">
                <p>➊ 文書全体が写っていない画像は受け付けできません。必ず書類の四隅が写るようにご撮影ください。</p>
                <p>➋ 書類に記載された氏名・住所・発行日などの情報がはっきり確認できる鮮明な写真をご提出ください。</p>
                <p>➌ 書類には氏名・住所・発行日が同一の書類上に明記されている必要があります。</p>
                <p>➍ 画像は編集ソフトやアプリ等で加工せず、そのまま送付してください。加工された画像は無効となり、受け付けできません。</p>
                <p>➎ 発行日から3か月以内の書類をご提出ください。</p>
                <p>➏ 当サイトに登録の住所と一致している必要があります。</p>
                <p>➐ 携帯電話等のカメラで撮影した紙の住所確認書類を撮影した画像のみを受け付けます。スキャナで取り込んだ画像や、デジタル化、スクリーンショットは一切認められません。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="sup-steps-box sup-steps-box--mt">
          <!-- ステップ3タイトル -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 3
            </p>
            <p class="sup-step-num sup-step-num--sub">
              KYC書類（本人確認書類）をアップロード
            </p>
          </div>

          <p class="sup-step-desc">
            KYC書類（本人確認書類）をアップロード後、通常30分以内に審査が完了します。<br>審査結果はメールでお知らせし、KYC認証が無事完了すると出金できるようになります。
          </p>

          <div class="sup-content-list">
            <p class="sup-content-list-item">
              ➊ ホーム画面の「詳細」＞「アカウント認証」をタップ
            </p>
            <p class="sup-content-list-item">
              ➋ 「KYC認証」をタップ
            </p>
            <p class="sup-content-list-item">
              ➌ 用意した身分証明書をアップロード
            </p>
            <p class="sup-content-list-item">
              ➍ 用意した住所確認用書類をアップロード
            </p>
          </div>

          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_kyc_8.jpg')" alt="KYC書類アップロード 画面1">
          </div>
          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_kyc_9.jpg')" alt="KYC書類アップロード 画面2">
          </div>

          <hr class="sup-step-divider">

          <!-- ※書類のアップロード方法※ -->
          <p class="sup-steps-box-title">
            ※書類のアップロード方法※
          </p>
          <div class="sup-content-list">
            <p class="sup-content-list-item">
              ➊ 用意した書類の種類を選択
            </p>
            <p class="sup-content-list-item">
              ➋ タップして書類の画像をアップロード
            </p>
            <p class="sup-content-list-item">
              ➌ 「アップロード」をタップすると完了
            </p>
          </div>

          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_kyc_10.jpg')" alt="アップロード方法 画面1">
          </div>
          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_kyc_11.jpg')" alt="アップロード方法 画面2">
          </div>
        </div>
        <p class="sup-page-footnote sup-page-footnote--gold">
          ※アップロードできない場合は、「<a href="/cdn-cgi/l/email-protection#6a191f1a1a05181e2a010b1e191f1d0304440b03" class="sup-footnote-link"><span class="__cf_email__" data-cfemail="15666065657a6761557e74616660627c7b3b747c">[email&nbsp;protected]</span></a>」までメールでご送付ください。
        </p>
        <p class="sup-page-footnote sup-page-footnote--red">
          ※「身分証明書」と「住所確認用書類」の両方ともアップロードが必要です。<br>片方のみは承認されません。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'account-verification',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
